define(function(require,) {
    'use strict';

    var AuthManager = require('managers/auth.manager');

    return AuthManager.extend({

        _getStartWindowSessionParams: function() {
            return {
                ...AuthManager.prototype._getStartWindowSessionParams.apply(this, arguments),
                subscriptionRequestedPlayerData: [123] // spanish regulations
            };
        }

    });
});
